import { getVisiblePages } from "helpers/pagination";
import { useEffect, useMemo, useState } from "react";

export default function usePagination(
    initialItems: {}[],
    options: { initialPageIndex?: number | undefined; initialPageSize?: number | undefined } = {},
) {
    const { initialPageIndex = 0, initialPageSize = 30 } = options;
    const calculateItems = () => {
        const itemsStart = pageIndex * pageSize;
        return allItems.slice(itemsStart, itemsStart + pageSize);
    };

    const [pageSize, setPageSize] = useState(initialPageSize);
    const [allItems, setAllItems] = useState(initialItems);
    const [key, setKey] = useState(Date.now());
    const [mounted, setMounted] = useState(false);

    const pagesCount = useMemo(() => {
        return Math.ceil(allItems.length / pageSize);
    }, [allItems, pageSize]);

    const [pageIndex, setPageIndex] = useState(initialPageIndex > pagesCount - 1 ? 0 : initialPageIndex);
    const [visiblePages, setVisiblePages] = useState(getVisiblePages(pageIndex + 1, pagesCount));
    const [pageItems, setPageItems] = useState(calculateItems());
    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!mounted) {
            return;
        }
        setPageItems(calculateItems());
        setVisiblePages(getVisiblePages(pageIndex + 1, pagesCount));
        setKey(Date.now());
    }, [pageIndex, pageSize, allItems]);

    const goToPage = (newPageIndex: number) => {
        if (newPageIndex > pagesCount - 1) {
            return;
        }
        setPageIndex(newPageIndex);
    };

    const updateItems = (newItems: {}[]) => {
        setPageIndex(0);
        setAllItems(newItems);
    };

    const updatePageSize = (value: number) => {
        setPageIndex(0);
        setPageSize(value);
    };

    return {
        page: { items: pageItems, pageIndex, pageSize, key },
        goToPage,
        setPageSize: updatePageSize,
        pagesCount,
        updateItems,
        visiblePages,
    };
}
